(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    popup();
    if (Shopify.designMode) {
      document.addEventListener('shopify:section:select', function (event) {
        if (event.target.classList.contains('newsletter-popup')) {
          popup();
        }
      });
    }
  });

  function popup() {
    const popup = document.querySelector('.newsletter-popup');
    if (!popup) return;
    const popupInner = popup.querySelector('[data-newsletter-popup]');
    if (popupInner) {
      const closedUntil = localStorage.getItem('newsletter_popup_closed_until');
      if (closedUntil && new Date().getTime() < parseInt(closedUntil, 10) && !Shopify.designMode) {
        popup.remove();
        return;
      }
      popup.classList.remove('hidden');
      popup.style.maxWidth = popupInner.dataset.width + 'px';

      setTimeout(() => {
        popup.classList.add('position-' + (popupInner.dataset.position || 'center'));
        popup.classList.add('is-visible');

        // Hide form success message if exists
        const isSuccess = popup.querySelector('[data-subscribe-success]');
        if (isSuccess) {
          setTimeout(() => {
            popup.classList.remove('is-visible');

            setTimeout(() => {
              popup.remove();
            }, 300);
            const hideForDays = parseInt(popupInner.dataset.hideForDays, 10) || 7;
            const expireTime = new Date().getTime() + hideForDays * 24 * 60 * 60 * 1000;
            localStorage.setItem('newsletter_popup_closed_until', expireTime);
          }, 3000);
        }
      }, parseInt(popupInner.dataset.delay, 10) * 1000);

      // Handle close button
      const closeButton = popup.querySelector('[data-modal-close]');
      closeButton.addEventListener('click', function (e) {
        if (Shopify.designMode) {
          e.preventDefault();
          return;
        }
        popup.classList.remove('is-visible');

        setTimeout(() => {
          popup.remove();
        }, 300);
        const hideForDays = parseInt(popupInner.dataset.hideForDays, 10) || 7;
        const expireTime = new Date().getTime() + hideForDays * 24 * 60 * 60 * 1000;
        localStorage.setItem('newsletter_popup_closed_until', expireTime);
      });
    } else {
      popup.remove();
      return;
    }
  }

  } catch(e) { console.error(e); }
})();
})();
